import React from 'react';

function Card({ children, style = {}, onClick, hoverable = false }) {
  const baseStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '16px',
    margin: '8px 0',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease-in-out',
    border: '1px solid #e0e0e0',
    ...style
  };

  const hoverStyle = hoverable ? {
    cursor: 'pointer'
  } : {};

  const handleMouseEnter = (e) => {
    if (hoverable) {
      e.target.style.transform = 'translateY(-3px)';
      e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
    }
  };

  const handleMouseLeave = (e) => {
    if (hoverable) {
      e.target.style.transform = 'translateY(0)';
      e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
    }
  };

  return (
    <div 
      style={{ ...baseStyle, ...hoverStyle }}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
}

export default Card;
